import { ReturnTranslatedText } from '@wajeez-web/core/localization';
import { useGetComponentTypeByIdMultilingual } from '@wajeez-web/components/helpers';

import { ComponentTypeFormBuilder } from './ComponentTypeFormBuilder';

interface ComponentTypeCreateFormWithPrefilledDataProps {
  onSubmit: (componentTypeId: number) => void;
  onCancel: () => void;
}

export const ComponentTypeCreateFormWithPrefilledData = ({
  onSubmit,
  onCancel,
}: ComponentTypeCreateFormWithPrefilledDataProps) => {
  const componentTypeByIdMultilingual = useGetComponentTypeByIdMultilingual();

  return (
    <div>
      <h1 className="text-[24px] font-bold">
        <ReturnTranslatedText
          text={`pageHeader.${'Create New Type'}`}
          origintext="Create New Type"
        />
      </h1>
      <div className="mt-6">
        {componentTypeByIdMultilingual.data && (
          <ComponentTypeFormBuilder
            type="Create"
            onSubmit={onSubmit}
            onCancel={onCancel}
            data={componentTypeByIdMultilingual.data}
          />
        )}
      </div>
    </div>
  );
};
